// The middleware origin, baked in at build time. Empty means same origin.
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/+$/, '');

export const LIMITED_LINK_KEY_HEADER = 'x-limited-link-key';
